import React from "react";
import {ErrorMessage, Field, Form, Formik} from "formik";
import Select, {createFilter} from "react-select";
/* Components */
import FormErrorMessage from "../../../common/form-elements/form-error-message/form-error-message";
import Input from "../../../common/form-elements/input/input";
import IconButton from "../../../common/icon-button/icon-button";
import ModalDefault from "../../../common/modal/modal-default";
import AdvancedQueryBuilder from "../../../common/advanced-query-builder/advanced-query-builder";
import ColumnDragAndDrop from "./column-drag-and-drop/ColumnDragAndDrop";
/* Helpers */
import {
    maxLength,
    minLength,
    required,
    requiredSelect,
    schemaValidate,
} from "../../../../helpers/validation-helpers";
import {
    getColumnsData,
    getFilterProperties,
} from "../../../../pagingfeed/column-helpers/filterProperties";
import {GRID_DATA_TYPE_OPTIONS} from "./constants";

class GridForm extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showFilterConfig: false,
            showColumnReorderAndSelectConfig: false,
        };
    }

    toggleFilterModal = () => {
        this.setState({
            showFilterConfig: !this.state.showFilterConfig,
        });
    };

    handleColumnConfigChange = (columnsConfig) => {
        this.setState({
            showColumnReorderAndSelectConfig: false,
        });
        this.props.saveColumnConfig(columnsConfig);
    };

    toggleColumnSelectAndReorderModal = () => {
        this.setState({
            showColumnReorderAndSelectConfig: !this.state.showColumnReorderAndSelectConfig,
        });
    };

    getColumnsConfig = () => {
        const columnsConfigObject = {};
        const columnsConfigKeys = Object.keys(this.props.tempConfigData.columnsConfig);
        columnsConfigKeys.forEach((key) => {
            columnsConfigObject[key] = this.props.tempConfigData.columnsConfig[key];
        });
        return columnsConfigObject;
    };

    render() {
        return (
            <Formik initialValues={this.props.initialValues} onSubmit={this.props.onFormSubmit}>
                {(props) => {
                    return (
                        <Form>
                            <div className="glu-modal__body">
                                <div className="glu-content__section">
                                    <div className="glu-form-row">
                                        <div className="glu-label">Widget Title</div>
                                        <Field
                                            as={Input}
                                            name="title"
                                            autoFocus
                                            className="glu-form-input-pad"
                                            value={props.values.title}
                                            onChange={this.props.handleFormFieldChange(
                                                "title",
                                                props
                                            )}
                                            validate={schemaValidate([
                                                required(),
                                                minLength(),
                                                maxLength(30),
                                            ])}
                                            invalid={props.errors.title && props.touched.title}
                                        />
                                        <ErrorMessage name="title" component={FormErrorMessage} />
                                    </div>
                                    <div className="glu-form-row">
                                        <div className="glu-label">Data</div>
                                        <Field
                                            as={Select}
                                            name="dataType"
                                            value={props.values.dataType}
                                            options={GRID_DATA_TYPE_OPTIONS}
                                            onChange={this.props.handleDataTypeChange(
                                                "dataType",
                                                props
                                            )}
                                            validate={schemaValidate([requiredSelect().nullable()])}
                                            invalid={
                                                props.errors.dataType && props.touched.dataType
                                            }
                                            className="glu-select glu-form-input-pad"
                                            classNamePrefix="react-select"
                                            filterOption={createFilter({
                                                matchFrom: "any",
                                                stringify: (option) => `${option.label}`,
                                            })}
                                        />
                                        <ErrorMessage
                                            name="dataType"
                                            component={FormErrorMessage}
                                        />
                                    </div>

                                    <div className="glu-form-row">
                                        <div className="glu-flex-row">
                                            <IconButton
                                                icon="filter"
                                                text={
                                                    Object.keys(
                                                        this.props.tempConfigData.filter
                                                            .mongoQuery || {}
                                                    ).length
                                                        ? "Configure filter"
                                                        : "Add filter"
                                                }
                                                onClick={this.toggleFilterModal}
                                                className={`glu-flex-shrink ${
                                                    Object.keys(
                                                        this.props.tempConfigData.filter
                                                            .mongoQuery || {}
                                                    ).length
                                                        ? "active"
                                                        : ""
                                                }`}
                                                isDisabled={
                                                    Object.keys(this.props.tempConfigData.dataType)
                                                        .length === 0
                                                }
                                            />
                                            <IconButton
                                                icon="sorting"
                                                text="Select and reorder columns"
                                                onClick={this.toggleColumnSelectAndReorderModal}
                                                className="glu-flex-shrink"
                                                isDisabled={
                                                    Object.keys(this.props.tempConfigData.dataType)
                                                        .length === 0
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <footer className="glu-modal__footer">
                                <div className="glu-flex-grow glu-flex-row">
                                    <div className="glu-flex-grow text-right">
                                        <button
                                            onClick={this.props.onCancel}
                                            className="glu-btn glu-btn--secondary"
                                            type="button"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="glu-flex-shrink">
                                        <button
                                            className="glu-btn glu-btn--primary"
                                            type="submit"
                                            disabled={this.props.isLoadingColumnConfig}
                                        >
                                            {this.props.isLoadingColumnConfig
                                                ? "Loading..."
                                                : "Save"}
                                        </button>
                                    </div>
                                </div>
                            </footer>
                            <ModalDefault
                                isOpen={this.state.showFilterConfig}
                                customClass="glu-modal__filter"
                            >
                                <div className="glu-modal-content">
                                    <div className="glu-modal__header">
                                        <div className="glu-modal__title glu-flex-grow">Filter</div>
                                        <div className="glu-flex-shrink">
                                            <button
                                                aria-label="close"
                                                type="button"
                                                className="glu-btn-link g-icon g-icon-close"
                                                onClick={this.toggleFilterModal}
                                            />
                                        </div>
                                    </div>
                                    <div className="glu-modal__body">
                                        <div className="glu-content__section">
                                            <Field name="filter">
                                                {() => (
                                                    <AdvancedQueryBuilder
                                                        saveFilter={this.props.handleFormFieldChange(
                                                            "filter",
                                                            props
                                                        )}
                                                        closeConfigModal={this.toggleFilterModal}
                                                        tree={this.props.tempConfigData.filter.tree}
                                                        type={this.props.tempConfigData.dataType}
                                                        columns={getColumnsData(
                                                            // eslint-disable-next-line max-len
                                                            getFilterProperties(
                                                                this.props.tempConfigData.dataType
                                                                    .value
                                                            ),
                                                            this.props.tempConfigData.columnsConfig
                                                        )}
                                                        filterData={
                                                            this.props.tempConfigData.filter
                                                                .mongoQuery
                                                        }
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                            </ModalDefault>
                            <ModalDefault
                                isOpen={this.state.showColumnReorderAndSelectConfig}
                                customClass="glu-modal__filter"
                            >
                                <div className="glu-modal-content">
                                    <div className="glu-modal__header">
                                        <div className="glu-modal__title glu-flex-grow">
                                            Select and reorder columns
                                        </div>
                                        <div className="glu-flex-shrink">
                                            <button
                                                aria-label="close"
                                                type="button"
                                                className="glu-btn-link g-icon g-icon-close"
                                                onClick={this.toggleColumnSelectAndReorderModal}
                                            />
                                        </div>
                                    </div>
                                    <div className="glu-modal__body">
                                        <div className="glu-content__section">
                                            <ColumnDragAndDrop
                                                saveColumnConfig={this.handleColumnConfigChange}
                                                columnsConfig={this.getColumnsConfig()}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </ModalDefault>
                        </Form>
                    );
                }}
            </Formik>
        );
    }
}

export default GridForm;
